<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="我的积分" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <div class="awardCon">
      <div>我的积分</div>
      <div class="awardNum">{{award||0}}</div>
    </div>
  </div>
</template>
<script>
import { myAward } from "@/api/personal";
export default {
  data() {
    return {
      award:0
    };
  },
  created(){
    myAward().then(res=>{
      this.award=res.award_money
    })
  }
};
</script>
<style lang='less' scoped>
.wrap {
  height: 100vh;
  background: #f5f5f5;
  .awardCon {
    background: url("../../assets/imgs/personal/walletBg.png") 0 0 no-repeat;
    width: 100%;
    height: 129px;
    width: 354px;
    margin: 10px auto;
    box-sizing: border-box;
    padding: 18px 0 0 14.5px;
    color: #fff;
    font-size: 12px;
    .awardNum {
      margin-top: 13.5px;
      font-size: 24px;
    }
  }
}
</style>